import { render, staticRenderFns } from "./AssemblyCalendarGantt.vue?vue&type=template&id=37c70b0b&scoped=true"
import script from "./AssemblyCalendarGantt.vue?vue&type=script&lang=js"
export * from "./AssemblyCalendarGantt.vue?vue&type=script&lang=js"
import style0 from "./AssemblyCalendarGantt.vue?vue&type=style&index=0&id=37c70b0b&prod&lang=scss"
import style1 from "./AssemblyCalendarGantt.vue?vue&type=style&index=1&id=37c70b0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c70b0b",
  null
  
)

export default component.exports